import { useState, useEffect, createContext } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Footer from './components/footer/Footer'
import Login from './pages/Login'
import CreateAccount from './pages/CreateAccount'
import CreateAccountSucess from './pages/CreateAccountSuccess'
import RecoverPassword from './pages/RecoverPassword'
import RecoverPasswordCode from './pages/RecoverPasswordCode'
import RecoverPasswordNew from './pages/RecoverPasswordNew'
import RecoverPasswordSuccess from './pages/RecoverPasswordSuccess'
import ClientProfile from './pages/ClientProfile'
import Schedules from './pages/Schedules'
import ScheduleDetails from './pages/ScheduleDetails'
import NewSchedule from './pages/NewSchedule'
import NewScheduleFairing from './pages/NewScheduleFairing'
import NewScheduleMooring from './pages/NewScheduleMooring'
import NewScheduleElectricitySupply from './pages/NewScheduleElectricitySupply'
import NewScheduleFacilities from './pages/NewScheduleFacilities'
import Boats from './pages/Boats'
import NewBoat from './pages/NewBoat'
import BoatDetails from './pages/BoatDetails'
import EditBoat from './pages/EditBoat'
import SchedulesBO from './pages/SchedulesBO'
import SuggestSchedule from './pages/SuggestSchedule'
import UsersBO from './pages/UsersBO'
import EntitiesBO from './pages/EntitiesBO'
import NewUserHarborTechnician from './pages/NewUserHarborTechnician'
import NewUserHarborAdmin from './pages/NewUserHarborAdmin'
import NewUserDealer from './pages/NewUserDealer'
import EditClient from './pages/EditClient'
import EditHarborTechnician from './pages/EditHarborTechnician'
import EditHarborAdmin from './pages/EditHarborAdmin'
import EditDealer from './pages/EditDealer'
import UserDetails from './pages/UserDetails'
import NewEntity from './pages/NewEntity'
import NewEntitySkills from './pages/NewEntitySkills'
import EditEntitySkills from './pages/EditEntitySkills'
import EditEntity from './pages/EditEntity'
import EntityDetails from './pages/EntityDetails'
import LoadingModal from './components/modals/LoadingModal'
import NotFound from './pages/NotFound'

export const UserContext = createContext()

const App = () => {
  const [loggedUser, setLoggedUser] = useState('refresh')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const rememberUser = localStorage.getItem('rememberUser')
    const authToken = localStorage.getItem('authToken')

    if(rememberUser === 'true') {
      if(authToken !== null) {
        setIsLoading(true)

        // Get user details and validate token
        fetch('/api/User/Details', {
          method:'GET',
          headers: { 
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + authToken
          },
          mode: 'cors'
        }).then(async response => {
          setTimeout(async () => {
            setIsLoading(false)

            if (response.status === 200) {
              const jsonRes = await response.json()
              localStorage.setItem('authToken', jsonRes.jwtToken)
  
              setLoggedUser(jsonRes)
  
            } else {
              setLoggedUser(null)
              localStorage.setItem('authToken', null)
            }
          }, 1000)

        }).catch((error) => {
          setTimeout(() => {
            setIsLoading(false)
            setLoggedUser(null)
          }, 1000)

          console.log(error)
        })
      } else {
        setLoggedUser(null)
      }
    } else {
      setLoggedUser(null)
    }
  }, [])

  if (isLoading) {
    return <LoadingModal />
  }

  return (
    <UserContext.Provider value={{ loggedUser, setLoggedUser }}>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Login/>}/>
          <Route path='/schedules' element={<Schedules/>}/> 
          <Route path='/schedule-details/:id' element={<ScheduleDetails/>}/>
          <Route path='/new-schedule' element={<NewSchedule/>} />
          <Route path='/new-schedule-fairing' element={<NewScheduleFairing/>}/>
          <Route path='/new-schedule-mooring' element={<NewScheduleMooring/>}/>
          <Route path='/new-schedule-electricity-supply' element={<NewScheduleElectricitySupply/>}/>
          <Route path='/new-schedule-facilities' element={<NewScheduleFacilities/>}/>
          <Route path='/suggest-schedule/:id' element={<SuggestSchedule/>}/>
          <Route path='/backoffice-schedules' element={<SchedulesBO/>}/>

          <Route path='/boats' element={<Boats/>}/>
          <Route path='/new-boat' element={<NewBoat/>}/>
          <Route path='/boat-details/:id' element={ <BoatDetails/>}/>
          <Route path='/edit-boat/:id' element={<EditBoat/>}/>
          
          <Route path='/backoffice-users' element={<UsersBO/>}/>
          <Route path='/new-harbor-technician' element={<NewUserHarborTechnician/>}/>
          <Route path='/new-harbor-admin' element={<NewUserHarborAdmin/>}/>
          <Route path='/new-dealer' element={<NewUserDealer/>}/>
          <Route path='/edit-client/:id' element={<EditClient/>}/>
          <Route path='/edit-harbor-technician/:id' element={<EditHarborTechnician/>}/>
          <Route path='/edit-harbor-admin/:id' element={ <EditHarborAdmin/>}/>
          <Route path='/edit-dealer/:id' element={<EditDealer/>}/>
          <Route path='/user-details/:id' element={<UserDetails/>}/>

          <Route path='/backoffice-entities' element={<EntitiesBO/>}/>
          <Route path='/new-entity' element={<NewEntity/>}/>
          <Route path='/edit-entity/:id' element={<EditEntity/>}/>
          <Route path='/new-entity-skills' element={<NewEntitySkills/>}/>
          <Route path='/edit-entity-skills' element={<EditEntitySkills/>}/>
          <Route path='/entity-details/:id' element={ <EntityDetails/>}/>

          <Route path='/' element={<Login/>}/>
          <Route path='/create-account' element={<CreateAccount/>} />
          <Route path='/create-account-success' element={<CreateAccountSucess/>} />
          <Route path='/recover-password' element={<RecoverPassword/>} />
          <Route path='/recover-password-code' element={<RecoverPasswordCode/>} />
          <Route path='/recover-password-new' element={<RecoverPasswordNew/>} />
          <Route path='/recover-password-success' element={<RecoverPasswordSuccess/>} />
          <Route path='/profile' element={<ClientProfile/>} />

          <Route path='*' element={<NotFound/>} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </UserContext.Provider>
  )
}

export default App